var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContainers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51782 6.46436H14.8895C15.6461 6.46436 16.2293 7.13131 16.1283 7.88119L14.7431 18.1667C14.6596 18.787 14.1302 19.2499 13.5043 19.2499H4.83152C4.20239 19.2499 3.6713 18.7823 3.59159 18.1583L2.27789 7.87272C2.18246 7.12558 2.7646 6.46436 3.51782 6.46436Z",
    fill: "#DAFFF0",
    stroke: "#DAFFF0",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.09521L17.4286 3.09522",
    stroke: "#DAFFF0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22294 0.999999C7.22294 0.447715 7.67065 0 8.22294 0H10.2056C10.7579 0 11.2056 0.447715 11.2056 1V1.90476V2.80952C11.2056 3.36181 10.7579 3.80952 10.2056 3.80952H8.22294C7.67065 3.80952 7.22294 3.36181 7.22294 2.80952V0.999999Z",
    fill: "#DAFFF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0893 6.46436H21.4609C22.2176 6.46436 22.8007 7.13131 22.6997 7.88119L21.3146 18.1667C21.231 18.787 20.7016 19.2499 20.0758 19.2499H11.403C10.7738 19.2499 10.2427 18.7823 10.163 18.1583L8.84933 7.87272C8.7539 7.12558 9.33604 6.46436 10.0893 6.46436Z",
    fill: "#78C2A5",
    stroke: "#78C2A5",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57143 3.09521L24 3.09522",
    stroke: "#78C2A5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7944 0.999999C13.7944 0.447715 14.2421 0 14.7944 0H16.7771C17.3293 0 17.7771 0.447715 17.7771 1V1.90476V2.80952C17.7771 3.36181 17.3293 3.80952 16.7771 3.80952H14.7944C14.2421 3.80952 13.7944 3.36181 13.7944 2.80952V0.999999Z",
    fill: "#78C2A5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainers);
export default __webpack_public_path__ + "static/media/Containers.fa0fc34797ae4261f92cfcfbd696c058.svg";
export { ForwardRef as ReactComponent };